import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c0fa3ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "discussion" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "discussion__me" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = ["placeholder", "disabled", "onKeydown"]
const _hoisted_6 = { class: "discussion__box-foot" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_9 = { class: "discussion__label" }
const _hoisted_10 = { class: "discussion__thread" }
const _hoisted_11 = {
  key: 1,
  class: "discussion__label"
}
const _hoisted_12 = {
  key: 2,
  class: "discussion__thread"
}
const _hoisted_13 = {
  key: 3,
  class: "discussion__empty"
}

import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { Actions } from '@/store/enums/StoreEnums';
import HcIcon from '@/modern/components/ui/HcIcon.vue';
import DiscussionPost from './DiscussionPost.vue';
import { useCourseI18n } from '../course';


export default /*#__PURE__*/_defineComponent({
  props: {
    lessonId: null,
    hacktivities: null
  },
  emits: ["changed"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'changed'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  lessonId: number
  hacktivities: any[]
}





const MAX_LENGTH = 190;
const PAGE_SIZE = 5;

const store = useStore();
const { t, lang, tc } = useCourseI18n();

const user = computed(() => store.getters.currentUser);
const pinned = computed(() => props.hacktivities.filter(feed => feed.is_fixed));
const recent = computed(() => props.hacktivities.filter(feed => !feed.is_fixed));

const visibleCount = ref(PAGE_SIZE);
const visible = computed(() => recent.value.slice(0, visibleCount.value));

const headline = ref('');
const posting = ref(false);
const touched = ref(false);
const tooLong = computed(() => headline.value.length > MAX_LENGTH);
const isEmpty = computed(() => !headline.value.trim());

watch(() => props.lessonId, () => {
  visibleCount.value = PAGE_SIZE;
  headline.value = '';
  touched.value = false;
});

const publish = async () => {
  touched.value = true;
  if (isEmpty.value || tooLong.value || posting.value) return;
  posting.value = true;
  try {
    await store.dispatch(Actions.ADD_HACKTIVITY, { id: props.lessonId, headline: headline.value.trim() });
    headline.value = '';
    touched.value = false;
    emit('changed');
  } catch (error) {
    console.error('Error posting hacktivity:', error);
  } finally {
    posting.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "discussion__composer",
      onSubmit: _withModifiers(publish, ["prevent"])
    }, [
      _createElementVNode("span", _hoisted_3, [
        (_unref(user)?.avatar)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _unref(user).avatar,
              alt: _unref(user)?.nick
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["discussion__box", { 'discussion__box--error': touched.value && (_unref(isEmpty) || _unref(tooLong)) }])
      }, [
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((headline).value = $event)),
          placeholder: _unref(t)(`${_unref(lang)}.hacktivity.ask_question_comment_about_this_class`),
          disabled: posting.value,
          rows: "3",
          onKeydown: [
            _withKeys(_withModifiers(publish, ["ctrl"]), ["enter"]),
            _withKeys(_withModifiers(publish, ["meta"]), ["enter"])
          ]
        }, null, 40, _hoisted_5), [
          [_vModelText, headline.value]
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", {
            class: _normalizeClass({ 'discussion__limit--over': _unref(tooLong) })
          }, [
            _createTextVNode(_toDisplayString(headline.value.length) + "/" + _toDisplayString(MAX_LENGTH) + " ", 1),
            (touched.value && _unref(isEmpty))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" · " + _toDisplayString(_unref(t)(`${_unref(lang)}.hacktivity.comment_is_required`)), 1)
                ], 64))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("button", {
            type: "submit",
            class: "lp-btn lp-btn--sm",
            disabled: posting.value || _unref(tooLong)
          }, [
            (posting.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8))
              : (_openBlock(), _createBlock(HcIcon, {
                  key: 1,
                  name: "send",
                  size: 15
                })),
            _createTextVNode(" " + _toDisplayString(_unref(tc)('publish')), 1)
          ], 8, _hoisted_7)
        ])
      ], 2)
    ], 40, _hoisted_2),
    (_unref(pinned).length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("h4", _hoisted_9, [
            _createVNode(HcIcon, {
              name: "pin",
              size: 15,
              class: "discussion__pin"
            }),
            _createTextVNode(_toDisplayString(_unref(tc)('pinned')), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pinned), (feed) => {
              return (_openBlock(), _createBlock(DiscussionPost, {
                key: feed.id,
                feed: feed,
                "lesson-id": __props.lessonId,
                pinned: "",
                onChanged: _cache[1] || (_cache[1] = ($event: any) => (emit('changed')))
              }, null, 8, ["feed", "lesson-id"]))
            }), 128))
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_unref(recent).length)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_11, _toDisplayString(_unref(tc)('recent_comments')), 1))
      : _createCommentVNode("", true),
    (_unref(recent).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visible), (feed) => {
            return (_openBlock(), _createBlock(DiscussionPost, {
              key: feed.id,
              feed: feed,
              "lesson-id": __props.lessonId,
              onChanged: _cache[2] || (_cache[2] = ($event: any) => (emit('changed')))
            }, null, 8, ["feed", "lesson-id"]))
          }), 128))
        ]))
      : (!_unref(pinned).length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
            _createVNode(HcIcon, {
              name: "chat",
              size: 18
            }),
            _createTextVNode(_toDisplayString(_unref(tc)('no_comments')), 1)
          ]))
        : _createCommentVNode("", true),
    (_unref(recent).length > visibleCount.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 4,
          type: "button",
          class: "lp-btn lp-btn--outline lp-btn--block discussion__more",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (visibleCount.value += PAGE_SIZE))
        }, _toDisplayString(_unref(tc)('show_more_comments')), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})